
import Vue from 'vue';
import { Data as ArticleData, Picture } from '@root/modules/article/types/article';
import getArticleLeadPictureCropperProps from '@root/modules/article/utils/getArticleLeadPictureCropperProps';
import articleConfig from '@root/modules/article/config/article.config';
import ContentImage from '@core/components/UI/ContentImage.vue';

const sizeMap: Record<string, Record<string, unknown>> = articleConfig.infoCover;
const imageRatio = '16:9';

interface Props {
  article: ArticleData;
}
interface Computed {
  picture: Picture | null;
  title: string;
  subtitle: string;
}
export default Vue.extend<unknown, unknown, Computed, Props>({
  components: {
    ContentImage,
  },
  props: {
    article: {
      required: true,
    },
  },
  computed: {
    picture() {
      const { leadElement } = this.article.content;
      const leadElementContent = leadElement.content.length > 0 ? leadElement.content[0] : null;

      if (!leadElementContent) {
        return null;
      }

      const baseCropperData = getArticleLeadPictureCropperProps(leadElementContent.attrs.cropperData, imageRatio, this.article.id);

      leadElementContent.attrs.cropperData = {
        ...sizeMap['normal'],
        ...leadElementContent.attrs.cropperData,
        base: baseCropperData,
      };
      return leadElementContent;
    },
    title() {
      return this.article.content.title.html.replace(/(<\/?h1>)/gi, '');
    },
    subtitle() {
      return this.article.content.subtitle.text || String(this.$t('words.live'));
    },
  },
});
